import React from 'react';
import { withLocalize } from "react-localize-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from 'reactstrap';
import { isNullOrUndefined } from '../../store/storeFunctions';
import classnames from "classnames";

import BbPopover from "./popover"
import './legendComponent.scss';

class Legend extends React.Component {
    state = { tooltipOpen: false }

    render() {
        if(isNullOrUndefined(this.props.id) || isNullOrUndefined(this.props.children) || React.Children.count(this.props.children) === 0)
            return null;

        return (
            <span className="bb-legend" onClick={(e) => e.stopPropagation()} style={this.props.style}>
                <span href="#" id={this.props.id} className={classnames('print-hidden',{'icon-gray':!this.props.white})} style={{ cursor: "pointer" }}>
                    <FontAwesomeIcon icon="question-circle" />
                </span>
                <Tooltip
                    placement="left"
                    trigger="click"
                    target={this.props.id}
                    isOpen={this.state.tooltipOpen}
                    toggle={() => this.setState({ tooltipOpen: !this.state.tooltipOpen })}
                    innerClassName='bb-tooltip-inner'
                >
                    <BbPopover content={this.props.children} title={this.props.title}
                               placement="left"
                               />
                </Tooltip>
            </span>
        )
    }
}

export default withLocalize(Legend);
